import { render, staticRenderFns } from "./imgFile.vue?vue&type=template&id=2970fd55&scoped=true"
import script from "./imgFile.vue?vue&type=script&lang=js"
export * from "./imgFile.vue?vue&type=script&lang=js"
import style0 from "./imgFile.vue?vue&type=style&index=0&id=2970fd55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2970fd55",
  null
  
)

export default component.exports